
import {
  Vue,
  Component,
  Watch,
  Prop,
  Model,
  Emit,
} from 'vue-property-decorator';
import { BASE_URL } from '@/common/constant';
import lazyInject from '@/di';
import UserService from '@/services/user.service';
import { ISPUImageUploadOptions } from '@/common/interface/spu';
import { $delay } from '@/common/utils';
import { IImage } from '@/common/interface';
import moment from 'moment';

@Component({})
export default class AudioShopUpload extends Vue {
  val: IImage = {
    id: 0,
    url: '',
  };

  moment = moment;

  acceptAudio = 'audio/*';

  called_phone = '';

  visible = false;

  uploading = false;

  BASE_URL = BASE_URL;

  labelArray = [];

  labelChangeId = '1';

  startTime = '';

  options: ISPUImageUploadOptions = {
    allowDuplicateUploads: false,
    target: `${BASE_URL}/tool/upload`,
    testChunks: false,
    headers: {},
    chunkSize: 5 * 1024 * 1024,
  };

  token: string | undefined = undefined;

  @Prop()
  placeholder?: string;

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  refs!: any;

  @Prop()
  kaId!: number;

  @Prop()
  shopData!: any;

  @Model()
  value!: IImage;

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = { ...this.value };
    } else {
      this.val = { id: 0, url: '' };
    }
  }

  @Emit('update')
  updateVal() {
    return this.val;
  }

  @lazyInject(UserService)
  protected userService!: UserService;

  beforeUpload() {
    const isJpgOrPng = this.called_phone !== '';

    const isPhone = /1[3-9]\d{9}/.test(this.called_phone);

    const { startTime } = this;
    if (!isJpgOrPng || !isPhone || !startTime) {
      let _test = '';

      if (!isJpgOrPng) {
        _test = '请先填写电话';
      } else if (!isPhone) {
        _test = '手机号不合法，请检测并重新输入！';
      }
      if (!startTime) {
        _test = `${_test},请选择录音时间`;
      }
      this.$message.warn(_test);
    }

    return isJpgOrPng && isPhone && startTime;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async onChange(info: any) {
    if (info.file.status === 'uploading') {
      this.uploading = true;
    }
    if (info.file.status === 'error') {
      this.uploading = false;
      const { code, error } = info.file.response;
      if (code === 401) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        });
      } else {
        this.$message.error(error);
      }
    }
    if (info.file.status === 'done') {
      this.$message.success('上传成功');
      this.close();
      this.$emit('onReset');
      this.uploading = false;
    }
  }

  created() {
    this.options.headers.AUTHORIZATION = this.userService.currentUser()?.token;
    this.token = this.userService.currentUser()?.token;
  }

  open() {
    this.visible = true;
    this.called_phone = '';
    this.labelArray = this.shopData.label.split(',');
    if (this.labelArray.length === 2) {
      this.labelChangeId = '1';
    } else {
      this.labelChangeId = this.shopData.labelId;
    }

    console.log(this.labelArray);
  }

  close() {
    this.visible = false;
    this.called_phone = '';
    this.startTime = '';
  }

  mounted() {
    this.watchValue();
  }

  onChangePaymentTime(e: any) {
    console.log(e);
    this.startTime = e;
  }
}
